// extracted by mini-css-extract-plugin
export var sliderRange = "_ph-2";
export var sliderRoot = "_ph-0";
export var sliderThumb = "_ph-3";
export var sliderTrack = "_ph-1";